import { render } from "./ProductsEnded.vue?vue&type=template&id=7714440c&scoped=true"
import script from "./ProductsEnded.vue?vue&type=script&lang=js"
export * from "./ProductsEnded.vue?vue&type=script&lang=js"

import "./ProductsEnded.vue?vue&type=style&index=0&id=7714440c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7714440c"]])

export default __exports__